<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
      <form data-vv-scope="PartitionInscription" @submit.prevent="PartitionInscription_validate">
        <div class="mt-6 flex items-center justify-between px-6">
            <h4>{{ Object.entries(this.data).length === 0 ? $t("new") : $t("update_a") }} {{ $t("student_by_partition") }}</h4>
            <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"/>
        </div>
        <vs-divider class="mb-0" />
        <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
            <div class="px-6 py-2">

              <p > {{ $t('room') }} <b style="color: #ff6141">*</b> </p>
              <v-select 
                :options="salles"
                @search="getSalle" 
                :clearable="true" 
                label="libelle"
                v-model="input.salle"
                class="w-full" name="salle" v-validate="'required'"/>                
              <span class="text-danger">{{ errors.first('PartitionInscription.salle') }}</span>

              <p class="mt-5"> {{ $t('partition') }} <b style="color: #ff6141">*</b> </p>
              <v-select 
                :disabled="input.salle ? false : true"
                :options="partitions"
                @search="getPartition" 
                :clearable="true" 
                label="long_label"
                v-model="input.partition"
                class="w-full" name="partition" v-validate="'required'"/>                
              <span class="text-danger">{{ errors.first('PartitionInscription.partition') }}</span>

              <p class="mt-5"> {{ $t('Student') }} <b style="color: #ff6141">*</b> </p>
              <v-select 
                :disabled="input.partition ? false : true"
                :options="inscriptions"
                @search="getInscription" 
                :clearable="true" 
                :getOptionLabel="getOptionLabel"
                v-model="input.inscription"
                class="w-full" name="inscription" v-validate="'required'"/>                
              <span class="text-danger">{{ errors.first('PartitionInscription.inscription') }}</span>
            </div>
        </VuePerfectScrollbar>
        
        <div v-if="!detail__detail" class="flex flex-wrap items-center p-6" slot="footer">
          <vs-button @click="PartitionInscription_validate" class="mr-6">{{ $t("Submit") }}</vs-button>
          <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{ $t("Cancel") }}</vs-button>
        </div>
      </form>
    </vs-sidebar>
</template>

<script>
let base_self = ''
const input_tempon = {
  id: null, 
  libelle: '',
  anneeScolaire: '',
  partition: '',
  inscription: '',
  salle: '',
  is_active: true
}

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { Validator } from 'vee-validate'

export default {
  components: {VuePerfectScrollbar},
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      label: ['eleve', 'full_name'],
      paramSalle: {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          q_list: [],
          is_active: true,
          classe__is_active: true,
          classe__niveau__niveauTypePartitions__anneeScolaire__id: this.$store.state.anneeScolaire.id,
          classe__niveau__is_active: true
        },
        orderby: ['ordre'],
        exclude: { code: 'Attente' }
      },
      paramInscription: {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          q_list: []
        }
      },
      paramPartition: {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          q_list: [],
          is_active: true
        },
        orderby: ['ordre']
      },
      salles: [],
      inscriptions: [],
      partitions: [],
      input: JSON.parse(JSON.stringify(input_tempon)),
      input1: JSON.parse(JSON.stringify(input_tempon)),
      detail__detail: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
        }
      }
    }
  },
  methods: {
    getOptionLabel (option) {
      if (typeof option === 'object') {
        const length = this.label.length
        let element = option
        for (let i = 0; i < length; i++) {
          if (!element.hasOwnProperty(this.label[i])) {
            return console.warn(
              `[vue-select warn]: Label key "option.${this.label}" does not` +
              ` exist in options object ${JSON.stringify(option)}.\n` +
              'https://vue-select.org/api/props.html#getoptionlabel'
            )
          }

          element = element[this.label[i]]
        }
          
        // return option['created_at']
        return element
      }
      return option
    },
    initPartitionForInput (partitions) {
      if (partitions.length === 1) {
        base_self.input.partition = JSON.parse(JSON.stringify(partitions[0]))
      } else {
        base_self.input.partition = ''
        window.getESM.error(base_self.$t('Please_activate_a_partition_before_continuing'))
      }
    },
    getPartitionSimple () {
      delete base_self.paramPartition.filter['long_label__icontains']
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Partition`, base_self.paramPartition)
        .then((response) => {
          base_self.partitions = JSON.parse(JSON.stringify(response.data.data))

          base_self.initPartitionForInput(response.data.data)
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },
    getPartition (search, loading) {
      loading(true)
      base_self.paramPartition.filter['long_label__icontains'] = search
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Partition`, base_self.paramPartition)
        .then((response) => {
          base_self.partitions = JSON.parse(JSON.stringify(response.data.data))

          base_self.initPartitionForInput(response.data.data)
          loading(false)
        })
        .catch((error) => { 
          loading(false)
          console.log('error: ', error)
        })
    },
    getInscriptionSimple () {
      delete base_self.paramInscription.filter['employe__full_name__icontains']
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Inscription`, base_self.paramInscription)
        .then((response) => {
          base_self.inscriptions = JSON.parse(JSON.stringify(response.data.data))
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },
    getInscription (search, loading) {
      loading(true)
      base_self.paramInscription.filter['eleve__full_name__icontains'] = search
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Inscription`, base_self.paramInscription)
        .then((response) => {
          base_self.inscriptions = JSON.parse(JSON.stringify(response.data.data))
          loading(false)
        })
        .catch((error) => { 
          loading(false)
          console.log('error: ', error)
        })
    },
    getSalleSimple () {
      delete base_self.paramSalle.filter['libelle__icontains']
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Salle`, base_self.paramSalle)
        .then((response) => {
          base_self.salles = JSON.parse(JSON.stringify(response.data.data))
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },
    getSalle (search, loading) {
      loading(true)
      base_self.paramSalle.filter['libelle__icontains'] = search
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Salle`, base_self.paramSalle)
        .then((response) => {
          base_self.salles = JSON.parse(JSON.stringify(response.data.data))
          loading(false)
        })
        .catch((error) => { 
          loading(false)
          console.log('error: ', error)
        })
    },
    PartitionInscription_validate () {
      base_self.$validator.validateAll('PartitionInscription').then(result => {
        if (result) {
          base_self.submitData()
        }
      })
    },
    async submitData () {
      const input = JSON.parse(JSON.stringify(this.input))
      const param = JSON.parse(JSON.stringify(base_self.$store.state.paramPartitionInscription))
      param.filter['partition__id'] = input.partition.id
      param.filter['inscription__id'] = input.inscription.id
      const response = await base_self.$http.post(`${base_self.$store.state.route_for_esm}PartitionInscription`, param)
        .catch((error) => { 
          console.log('error: ', error)
        })

      if (response.data.data.length) {
        if ((input.id && input.id !== response.data.data[0].id) || !input.id) {
          window.getESM.error(base_self.$t('This_registration_already_exists_Please_choose_another_registration'))
          return
        }
      }

      base_self.$vs.loading()
      // input.libelle = `${input.salle.libelle} - ${input.inscription.libelle} - ${input.partition.libelle}`
      input.inscription = input.inscription.id
      input.partition = input.partition.id
      
      if (!input.id) {     
        base_self.$http.post(`${base_self.$store.state.route_for_esm}PartitionInscription`, input)
          .then((response) => { 
            base_self.$vs.loading.close()
            window.getESM.success(base_self.$t('The_student_by_partition_is_added_successfully'), response)
            this.$emit('closeSidebar')
            this.initValues()
          })
          .catch((error) => { 
            base_self.$vs.loading.close()
            console.log('error: ', error)
          })

      } else if (input.id) {
        base_self.$http.put(`${base_self.$store.state.route_for_esm}PartitionInscription`, input)
          .then((response) => { 
            window.getESM.success(base_self.$t('The_student_by_partition_is_changed_successfully'), response)
            this.$emit('closeSidebar')
            this.initValues()
          })
          .catch((error) => { 
            console.log('error: ', error)
          })
      }
    },
    initValues () {
      base_self.input = JSON.parse(JSON.stringify(input_tempon))
      base_self.input1 = JSON.parse(JSON.stringify(input_tempon))
      base_self.detail__detail = false

      base_self.$validator.errors.clear() 
    }
  },
  watch: {
    input: {
      handler  () {
        if (base_self.input1.salle !== base_self.input.salle) {
          if (!base_self.input.salle || base_self.input.salle === '') {
            delete base_self.paramPartition.filter['niveauTypePartition__anneeScolaire__id']
            delete base_self.paramPartition.filter['niveauTypePartition__niveau__id']

            delete base_self.paramInscription.filter['anneeScolaire__id']
            delete base_self.paramInscription.filter['salle__id']
            base_self.partitions = []
          } else {
            base_self.paramPartition.filter['niveauTypePartition__anneeScolaire__id'] = base_self.$store.state.anneeScolaire.id
            base_self.paramPartition.filter['niveauTypePartition__niveau__id'] = base_self.input.salle.classe.niveau.id

            base_self.paramInscription.filter['anneeScolaire__id'] = base_self.$store.state.anneeScolaire.id
            base_self.paramInscription.filter['salle__id'] = base_self.input.salle.id
            base_self.getPartitionSimple()
            base_self.getInscriptionSimple()
          }
        }

        /* if (base_self.input1.inscription !== base_self.input.inscription) {
          if (!base_self.input.inscription || base_self.input.inscription === '') {
            delete base_self.param.filter['inscription']
          } else {
            base_self.param.filter['inscription'] = base_self.input.inscription
          }
        }

        if (base_self.input1.partition !== base_self.input.partition) {
          if (!base_self.input.partition || base_self.input.partition === '') {
            delete base_self.param.filter['partition']
          } else {
            base_self.param.filter['partition'] = base_self.input.partition
          }
        } */

        base_self.input1 = JSON.parse(JSON.stringify(base_self.input))
      },
      deep: true
    },
    async isSidebarActive () {
      base_self.initValues()
      base_self.getSalleSimple()
      
      if (base_self.data && base_self.data.id) {
        base_self.input = JSON.parse(JSON.stringify(base_self.data))
      }
    }
  },
  created () {
    base_self = this
    base_self.initValues()

    ///////////////////////////
    const dict = {
      custom: {
        salle: {
          required: base_self.$t('The_room_is_required')
        },
        inscription: {
          required: base_self.$t('The_Student_is_required')
        },
        partition: {
          required: base_self.$t('The_partition_is_required')
        }
      }
    }
    Validator.localize('en', dict)
    //////////////////////////
  }
}
</script>

<style lang="scss" scoped>
  .add-new-data-sidebar {
      ::v-deep .vs-sidebar--background {
          z-index: 52010;
      }

      ::v-deep .vs-sidebar {
          z-index: 52010;
          width: 400px;
          max-width: 90vw;

          .img-upload {
              margin-top: 2rem;

              .con-img-upload {
                  padding: 0;
              }

              .con-input-upload {
                  width: 100%;
                  margin: 0;
              }
          }
      }
  }

  .scroll-area--data-list-add-new {
      // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
      height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
      
  }
</style>
